








































































































































import { CampaignDetailsModule } from "@/store/modules/campaignDetails";
import { Component, Vue } from "vue-property-decorator";
import GiganautVue from "@/components/Shared/GiganautVue";
import { VuetifyConfirmObject } from "vuetify-confirm";
import CampaignGeneralDetailsEdit from '@/components/Campaigns/CampaignGeneralDetailsEdit.vue';
import CampaignEmailDetailsEdit from '@/components/Campaigns/CampaignEmailDetailsEdit.vue';
import CampaignStatus from "@/models/Campaigns/CampaignStatus";

@Component({
  name: "CampaignDetails",
  components: { CampaignEmailDetailsEdit, CampaignGeneralDetailsEdit },
})
export default class extends GiganautVue {
  
  campaignStatus = CampaignStatus;

  get campaign() {
    return CampaignDetailsModule.currentCampaign;
  }
}
